import script from "./PostingEditLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostingEditLink.vue?vue&type=script&setup=true&lang=ts"

import "./PostingEditLink.vue?vue&type=style&index=0&id=a892efda&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a892efda"]])

export default __exports__